import z from 'zod';

export const TaskHistoryEventPostSchema = z.object({
  task_token: z.string(),
  user_email: z.string(),
  task_state: z.string(),
});

export const TaskHistoryEventSchema = TaskHistoryEventPostSchema.extend({
  user_email: z.string(),
  updated_at: z.coerce.date(),
});

export type TaskHistoryEventPost = z.infer<typeof TaskHistoryEventPostSchema>;
export type TaskHistoryEvent = z.infer<typeof TaskHistoryEventSchema>;
